// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addProductWithResult } from "@insite/client-framework/Services/CartService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

export const XSendDataToApi: typeof SendDataToApi = async props => {
    const result = await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        // XNG-Change: just make sure we don't block the site
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });

        return false;
    }
};

replaceInChain(chain, SendDataToApi, XSendDataToApi);
